/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { scheduleOnce } from '@ember/runloop';

interface SqlImportsPreviewTableArgs {
  columns: string[];
  data: string[][];
}

const MAX_PREVIEW_ROWS = 100;

export default class SqlImportsPreviewTable extends Component<SqlImportsPreviewTableArgs> {
  @tracked mustScroll = false;

  get rows() {
    return this.args.data.slice(0, MAX_PREVIEW_ROWS);
  }

  @action
  onInsert(table: HTMLTableElement) {
    window.addEventListener('resize', this.updateMustScroll.bind(this, table));
    scheduleOnce('afterRender', this, this.updateMustScroll.bind(this, table));
  }

  @action
  onDestroy(table: HTMLTableElement) {
    window.removeEventListener('resize', this.updateMustScroll.bind(this, table));
  }

  @action
  onUpdate(table: HTMLTableElement) {
    scheduleOnce('afterRender', this, this.updateMustScroll.bind(this, table));
  }

  @action
  updateMustScroll(table: HTMLTableElement) {
    let container = document.querySelector('.js-page-container') as HTMLDivElement;
    if (!container) {
      return;
    }

    this.mustScroll = table.scrollWidth > container.offsetWidth;
  }
}
